import src from "IMAGE";
export default { src, width: 401, height: 233, blurWidth: 0, blurHeight: 0};
